export default __webpack_public_path__ + "static/webinar-mobile-7c342f7e597ca75df80b279e0f014fb0.png";